// Percorre recursivamente um objeto de erros do react-hook-form e retorna a primeira mensagem encontrada
export function findFirstErrorMessage(errorObj: any): string | undefined {
  if (!errorObj || typeof errorObj !== "object") return undefined;
  if (typeof errorObj.message === "string") return errorObj.message;
  for (const key of Object.keys(errorObj)) {
    const found = findFirstErrorMessage(errorObj[key]);
    if (found) return found;
  }
  return undefined;
}
